import { Alert } from 'foundations-components/transitional/components/Alert';
import { connect } from 'react-redux';
import { hideUserDeactivatedAlert } from '../../actions';
import { getIsUserDeactivatedAlertVisible, getVettingUrl } from '../../selectors/TwoFactorAuth';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const UserDeactivatedAlert = ({
  visible,
  hide,
  vettingUrl
}) => {
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    type: "danger",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "login.twoFactor.errors.deactivatedUser.title"
    }),
    closeable: true,
    onClose: hide,
    marginBlockEnd: "200",
    children: vettingUrl ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "login.twoFactor.errors.deactivatedUser.vetting_body_jsx",
      options: {
        href: vettingUrl
      },
      elements: {
        Link
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "login.twoFactor.errors.deactivatedUser.body"
    })
  });
};
UserDeactivatedAlert.propTypes = {
  visible: PropTypes.bool.isRequired,
  hide: PropTypes.func.isRequired,
  vettingUrl: PropTypes.string
};
const mapStateToProps = state => ({
  visible: getIsUserDeactivatedAlertVisible(state),
  vettingUrl: getVettingUrl(state)
});
export default connect(mapStateToProps, {
  hide: hideUserDeactivatedAlert
})(UserDeactivatedAlert);